import React, { useState, useEffect } from "react";
import { Button, Typography } from "antd";
import { openNotification } from "../../utilities.js";
import { CheckOutlined  } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedOption } from "../../redux/actions/submitPageComponentAction.js";
import { resetStore } from "../../redux/actions/resetStoreAction.js";
import { CustomAxios } from "../../service/axios.js";
import { submitModalTranslation } from "./contactBackTranslations.js";
import { useNavigate } from "react-router-dom";
import "./contactBackComponent.css";

const { Title } = Typography;

const ThankYouComponent = ({ onSubmitFeedback, submitText, thankYouMessage,thankYou, loading,hovered,
  setHovered,
  getButtonStyle }) => {
  return (
    <section className="thank-you-center">
      <div
        style={{
          width: 50,
          height: 50,
          borderRadius: '50%',
          backgroundColor: '#4caf50',
          border: '2px solid #4caf50',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 16
        }}
      >
      <CheckOutlined
        style={{
          color: 'white',
          fontSize: 24,   // tweak so the tick isn’t too big inside the 50px circle
        }}
      />
    </div>
      <Title level={3} className="title">
      
        {thankYouMessage}
        </Title>
        
        <Title level={3} className="sub-title">
        {thankYou}
      </Title>
      
    </section>
  );
};

const Submit = ({ onSubmit }) => {
  const [showThankYou, setShowThankYou] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedOption = useSelector((state) => state.submitComponent.selectedOption);
  const feedbackDataTotal = useSelector((state) => state.feedback.feedbackData);
  const userDetails = useSelector((state) => state.landingPage.userDetails);
  const selectedLanguage = useSelector((state) => state.language.selectedLanguage);
  const translations = submitModalTranslation[selectedLanguage] || submitModalTranslation.English;
  const [hovered, setHovered] = useState(null);
  const sendFeedback = async () => {
    try {
      const payload = {
        ...feedbackDataTotal,
        Email: userDetails?.email,
        Name: userDetails?.name,
        Region: userDetails?.region,
        Location: userDetails?.location,
        Market: userDetails?.market,
      };
      const response = await CustomAxios("/post-feedback", "POST", payload);
      console.log("Feedback submission response:", response);
      openNotification("success", translations.notificationSuccess, "custom-notification");
      dispatch(resetStore(true));
    } catch (error) {
      console.error("Error submitting feedback:", error);
      openNotification("error", translations.notificationError, "custom-notification");
    }
  };
  const getButtonStyle = (option) => {
    const isSelected = selectedOption === option;
    const isHovered = hovered === option;

    return {
      marginRight: "20px",
      width: "180px",
      height: "40px",
      backgroundColor: isSelected
        ? "#E0EBF1"
        : isHovered
        ? "#D1DDEA"
        : undefined,
      color: isSelected || isHovered ? "black" : undefined,
      borderColor: isHovered || isSelected ? "#CAD2D8" : undefined,
      borderWidth: "2px",
      borderStyle: "solid",
    };
  };
  const handleOptionSelect = (option) => {
    dispatch(setSelectedOption(option));
    
  };

  const handleSubmitFeedback = async () => {
    setLoading(true); 
    await sendFeedback(); 
    setLoading(false); 
    setShowThankYou(true);
    //navigate("/itux-happiness-survey", { replace: true });
  };

  useEffect(() => {
    console.log("Contact Back", selectedOption);
    console.log("Feedback Data:", feedbackDataTotal);
    console.log("User Details:", userDetails);
  }, [feedbackDataTotal, userDetails, selectedOption]);

  return (
    <>
      {!showThankYou ? (
        <section className="submit-section">
          <div className="content-wrapper">
           <Title level={4} className="title">
    <span className="subtitle">{translations.subtitle}</span>
    <span className="main-title">{translations.mainTitle}</span>
  </Title>

          <div style={{ display: "flex", gap: "12px",marginTop:"15px" }}>
            
            <Button
        type="default"
        className={`submit-button ${selectedOption === "Yes" ? "selected" : ""}`}
        style={getButtonStyle("Yes")}
        onClick={() => handleOptionSelect("Yes")}
        onMouseEnter={() => setHovered("Yes")}
        onMouseLeave={() => setHovered(null)}
      >
        {translations.yesButton}
      </Button>

      <Button
        type={selectedOption === "No" ? "primary" : "default"}
        className={`submit-button ${selectedOption === "No" ? "selected" : ""}`}
        style={getButtonStyle("No")}
        onClick={() => handleOptionSelect("No")}
        onMouseEnter={() => setHovered("No")}
        onMouseLeave={() => setHovered(null)}
      >
        {translations.noButton}
      </Button>
      </div>

          </div>
          <Button
            type="primary"
            className="thank-you-footer"
            disabled={!selectedOption}
            loading={loading}
            onClick={handleSubmitFeedback}
          >
            {translations.submit}
          </Button>
        </section>
      ) : (
        
        <ThankYouComponent
        className="thankyou"

        thankYouMessage={translations.thankYouMessage}
        thankYou={translations.thankYou}
        
        />
        
      )}
    </>
  );
};

export default Submit;
